import { Component, inject, Input, OnInit } from '@angular/core';
import {
  LargedTuileComponent,
  TuileButtonProps,
} from '../../../../../../../../components/ecosystems/larged-tuile/larged-tuile.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
  FunctionOnglet,
} from '../../../../../../manager/edro-network-manager';
import { IProduct, IProductFunctionnality } from '../../../../../IProduct';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import { SlideModalController } from '../../../../../../../slide-modal.service';
import { P0003600EnSavoirPlusComponent } from '../../../../P0003600/Filtration/enSavoirPlus/p0003600-en-savoir-plus/p0003600-en-savoir-plus.component';
import { P0003601EnSavoirPlusComponent } from '../../../EnSavoirPlus/p0003601-en-savoir-plus/p0003601-en-savoir-plus.component';
import { IonLabel, ModalController } from '@ionic/angular/standalone';
import convertSecondsToTime from '../../../../../../helper/convertSecondsToTime';
import {
  ModeControlData,
  ModeControlMultipleComponent,
} from '../../../../../../../../components/ecosystems/mode-control-multiple/mode-control-multiple.component';
import { P0003601SpeedChoiceComponent } from '../../../Component/p0003601-speed-choice/p0003601-speed-choice.component';

@Component({
  selector: 'app-p0003601-filtration-controle',
  templateUrl: './p0003601-filtration-controle.component.html',
  styleUrls: ['./p0003601-filtration-controle.component.scss'],
  imports: [
    LargedTuileComponent,
    TranslatePipe,
    IonLabel,
    ModeControlMultipleComponent,
  ],
})
export class P0003601FiltrationControleComponent implements OnInit {
  private slideModalcontroller: SlideModalController =
    inject(SlideModalController);
  private modalController: ModalController = inject(ModalController);
  private translateService: TranslateService = inject(TranslateService);

  @Input() productClass: IProduct | null = null;
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);

  public actionStack: DeviceActionStackService | null = null;

  constructor() {}

  buttons: ModeControlData[] = [
    {
      ref: 1,
      label: this.translateService.instant(
        'P0003601.filtration.controle.fonctionnement.manuel',
      ),
      icon: '',
      color: 'color-green',
      onPress: () => {
        this.actionStack!.editValue(
          P00039DataRxTxIndex.FiltrationVS_Controle,
          'fvsCModeFonctionnement',
          1,
        );
        this.actionStack!.commit();

        this.openManual().finally(() => {});
      },
    },
    {
      ref: 0,
      label: this.translateService.instant(
        'P0003601.card.state.filtration.status.off',
      ),
      icon: 'fa-kit fa-picto-off',
      color: 'color-red',
    },
    {
      ref: 2,
      label: this.translateService.instant(
        'P0003601.card.state.filtration.status.auto',
      ),
      icon: 'fa-kit fa-picto-programme',
      color: 'color-orange',
    },
  ];

  getButtons(): ModeControlData[] {
    const vitesseManuelle =
      this.actionStack!.getValue('fvsCVitesseManuelle') ?? 0;

    let res = 'fa-kit fa-vs-v1';

    if (vitesseManuelle === 1) {
      res = 'fa-kit fa-vs-v1';
    } else if (vitesseManuelle === 2) {
      res = 'fa-kit fa-vs-v2';
    } else if (vitesseManuelle === 3) {
      res = 'fa-kit fa-vs-max';
    }

    this.buttons[0].icon = res;

    return this.buttons;
  }

  async openManual() {
    const modal = await this.modalController.create({
      component: P0003601SpeedChoiceComponent,
      componentProps: {
        value: this.actionStack!.getValue('fvsCVitesseManuelle') ?? 0,
      },
      cssClass: 'dynamic-height',
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      this.actionStack!.editValue(
        P00039DataRxTxIndex.FiltrationVS_Controle,
        'fvsCVitesseManuelle',
        data.value,
      );
      this.actionStack!.commit();
    }
  }

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );
  }

  async openenSavoirPlus() {
    const modal = await this.slideModalcontroller.create({
      component: P0003601EnSavoirPlusComponent,
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly convertSecondsToTime = convertSecondsToTime;
}
